// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getCategorymaster = createAsyncThunk('categorymasterSliceData/getCategorymaster', async () => {
    try {
        let response = await axios.get('/Category', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getCategorymasteroption = createAsyncThunk('categorymasterSliceData/getCategorymasteroption', async () => {
    try {
        let response = await axios.get('/Category?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getDayAdjustmentStatus = createAsyncThunk('categorymasterSliceData/getDayAdjustmentStatus', async () => {
    try {
        let response = await axios.get('/Category?status=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deletecategorymaster = createAsyncThunk('categorymasterSliceData/deletecategorymaster', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Category/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Category deleted successfully.');
        await dispatch(getCategorymaster());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createcategorymaster = createAsyncThunk('categorymasterSliceData/createcategorymaster', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/Category', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Category added succesfully.');
        await dispatch(getCategorymaster());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updatecategorymaster = createAsyncThunk('categorymasterSliceData/updatecategorymaster', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Category/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Category updated succesfully.');
        await dispatch(getCategorymaster());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updatecategorymasterStatus = createAsyncThunk(
    'categorymasterSliceData/updatecategorymasterStatus',
    async (id, { dispatch }) => {
        try {
            let response = await axios.put('/Category/status/' + id, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            toast.success(response?.data?.message || 'Status Updated Succesfully');
            await dispatch(getCategorymaster());
            return Promise.resolve(response);
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            console.log('err', err);
            return Promise.reject(err);
        }
    }
);
export const categorymasterSlice = createSlice({
    name: 'categorymasterSliceData',
    initialState: {
        categorymaster: [],
        categorymasteroption: [],
        categorymasterStatus: []
    },
    extraReducers: (builder) => {
        builder.addCase(getCategorymaster.fulfilled, (state, action) => {
            state.categorymaster = action?.payload;
            return;
        });
        builder.addCase(getCategorymasteroption.fulfilled, (state, action) => {
            state.categorymasteroption = action?.payload;
            return;
        });
        builder.addCase(getDayAdjustmentStatus.fulfilled, (state, action) => {
            state.categorymasterStatus = action?.payload;
            return;
        });
    }
});

export default categorymasterSlice.reducer;
